export default __webpack_public_path__ + "static/cashflow_new_18-86e9e23d25246c6bdf5912076bea6723.jpg";